// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"f968b502","532":"6da3bd11"}[chunkId] + ".chunk.css";
};